// nagłówek zamówienia – lokalna wersja bez przycisku „Pobierz zdjęcia produktów z zamówienia”

import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';

import { useRWD } from 'hooks';
import { PageTitle } from 'components/controls';

import styles from 'theme/pages/Order/components/OrderHeader/OrderHeader.module.scss';

interface IProps {
  orderId: number;
}

const Header: FC<IProps> = ({ orderId }) => {
  const { isMobile } = useRWD();

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Order-components-OrderHeader'
      )}>
      {isMobile ? (
        <PageTitle
          title={
            <>
              <Trans>Szczegóły zamówienia</Trans>{' '}
            </>
          }
        />
      ) : (
        <h3 className={styles.title}>
          <Trans>Szczegóły zamówienia</Trans>
        </h3>
      )}
    </div>
  );
};

export default Header;
